var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-input-checkbox"},[_c('input',{staticClass:"base-input-checkbox__input",attrs:{"id":"base-input-checkbox__input","type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.emitInputEvent}}),_c('label',{staticClass:"base-input-checkbox__text",attrs:{"for":"base-input-checkbox__input"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }